import { UserWorkoutSession } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text } from 'react-native';
import { TranslateProp } from '../../../common-types';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils';

interface IParentProps {
  workout: UserWorkoutSession;
  t: TranslateProp;
}

const Zone: FunctionComponent<IParentProps> = (
  {
    workout,
    t,
  },
) => (
  <Text style={styles.zone}>
    {t('StartingStudioWorkoutHeaderZoneNumber', { number: UserWorkoutSession.getStartingZoneDisplayNumber(workout) })}
  </Text>
);

export default Zone;

const styles = StyleSheet.create({
  zone: {
    ...Theme.textStyle.heading2,
    paddingVertical: defaultScale(3),
    paddingHorizontal: defaultScale(8),
    borderWidth: defaultScale(2),
    borderColor: Theme.TEXT_DARK,
    borderRadius: defaultScale(5),
  },
});
